// extracted by mini-css-extract-plugin
export default {"buttonSave":"ImportRecordsModal_buttonSave__8aCWl","inputDownload":"ImportRecordsModal_inputDownload__tx8VP"};